export * from './Chat';
export * from './ChatNext';
export * from './Conversation';
export * from './ClientProvider';
export * from './DotComButton';
export * from './Widget';
export * from './theme';
export * from './AnalyticsProvider';
export * from './ThemeProvider';
export * from './RequestACall';
export * from './SendUsAnEmail';
export {FileUploaderProvider, useFileUploader} from './FileUploaderProvider';
export type {FileUploaderValue} from './FileUploaderProvider';
export type {FeatureFlags} from './FeatureFlagsProvider';
export {
  FeatureFlagsProvider,
  useConversationUIFeatureFlags,
  useDotComFeedbackButtons,
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
  useInlineRacEmailForm,
} from './FeatureFlagsProvider';
export {widgetLinkAction} from './helpers/widgetLinkAction';

export const ANIMATION_DURATION = 350;
